import { render, staticRenderFns } from "./FbAlert.vue?vue&type=template&id=8ee358c2&scoped=true"
import script from "./FbAlert.vue?vue&type=script&lang=js"
export * from "./FbAlert.vue?vue&type=script&lang=js"
import style0 from "./FbAlert.vue?vue&type=style&index=0&id=8ee358c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee358c2",
  null
  
)

export default component.exports